FiltersMdl.controller( 'SearchCtrl', [ '$scope', 'API_URL', '$http', 'MobileFiltersSrv', 'HuesUpdaterSrv', 'HuesSrv', function ( $scope, API_URL, $http, MobileFiltersSrv, HuesUpdaterSrv, HuesSrv ) {
	var self = this,
		searchResults = false;

	this.searchOn = false;


	/**
	 * Watcher for a service value changes.
	 * This value is being updating by other controllers on runtime according to the user actions on the page
	 * after the states has being loaded.
	 */
	$scope.$watch(function () { return MobileFiltersSrv.searchOn;}, function( searchOn ){
		self.searchOn = searchOn;
	});


	$scope.options = [];

	var search_input = '';

	this.searchHues = function( input ) {
		if( input.length < 2 )
			return;


		search_input = input;
		$http.get( API_URL.HUE + '/search-hue/' + input + '/type/name' ).then(
				function ( response ) {
					searchResults = response.data;
					if( searchResults.length ) {
						$scope.options = searchResults.map(function (item) {
							return item['hue'];
						});
					} else
						$scope.options = [];

				},
				function (error){
					console.log( error );
				}
		);
	};

	this.getResults = function(){

		if( search_input < 2 )
			return;

		processSearch();
		HuesSrv.setFilter('search_term', search_input );
		HuesSrv.setFilter('search_single', false );
		HuesUpdaterSrv.getHues = true;
	};

	this.getSingleResult = function( selected ){

		var hue_id = searchResults.filter(function (item) {
			return item['hue'] == selected;
		})[0].ID;


		processSearch();
		HuesSrv.setFilter('search_term', false );
		HuesSrv.setFilter('search_single', hue_id );
		HuesUpdaterSrv.getHues = true;
	};

	function processSearch() {
		$('html, body').animate({ scrollTop: angular.element('.the-fans .container').offset().top }, 800, function(){});
		HuesUpdaterSrv.isSearch = true;
		HuesUpdaterSrv.getHues = false;
		HuesSrv.setFilter('category', false );
		HuesSrv.setFilter('family', false );
		HuesSrv.setFilter('color_fan', false );
		HuesSrv.setFilter('effect_fan', false );
		HuesSrv.setFilter('subcategory', false );
		HuesSrv.setFilter('hue', false );

	}


	angular.element('.search-area button').on('click', self.getResults );




}]);

